import React from 'react';
import { Route } from 'react-router-dom';

import Client from '@pages/Client';
import ClientDetail from '@pages/Client/pages/Detail';
import ClientEdit from '@pages/Client/pages/Edit';
import ClientNew from '@pages/Client/pages/New';
import ClientAccount from '@pages/ClientAccount';
import ClientAccountDetail from '@pages/ClientAccount/pages/Detail';

import PageNotFound from '@components/Common/Error/PageNotFound';

const MasterRoute = () => {
  return (
    <>
      <Route path="/client" element={<Client />} />
      <Route path="/client/new" element={<ClientNew />} />
      <Route path="/client/:groupId" element={<ClientDetail />} />
      <Route path="/client/:groupId/edit" element={<ClientEdit />} />
      <Route path="/client-account" element={<ClientAccount />} />
      <Route
        path="/client-account/:groupId"
        element={<ClientAccountDetail />}
      />
      <Route path="*" element={<PageNotFound isInLayout />} />
    </>
  );
};

export default MasterRoute;
